import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Filter, VoceAcquisto} from "../_Models";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {Permission} from "../../Login/_guards/Permission";
import {ApiRestService} from "../api-rest.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-voci-spedizione-edit',
  templateUrl: './voci-spedizione-edit.component.html'
})
export class VociSpedizioneEditComponent implements OnInit {
  @Input() hasFiltri: boolean = true;
  @Input() isModal: boolean = false;
  @Input() Filtri: Filter = {page: 1, size: 10, stato: "T", periodo: false};
  @Output() AddClick = new EventEmitter();
  List: VoceAcquisto[];
  constructor(
    private modalService: NgbModal,
    private paginationService: ServerPaginationService,
    public permission: Permission,
    private apirestservice: ApiRestService,
    private ngbActiveModal: NgbActiveModal,
    private toastrService: ToastrService

  ) { }

  ngOnInit(): void {
    this.refreshTable();
  }
  Add(item: VoceAcquisto){
    item.voce_id = item.id;
    item.ordine = item.anno + "/" + item.progressivo;
    if(item?.quantita <= item.disponibilita ) {
      this.AddClick.emit(Object.assign({}, item));
      item.disponibilita = item?.disponibilita - item?.quantita;
    }
    else
      this.toastrService.warning("La quantità non deve essere maggiore della disponibilità")
  }
  close() {
    this.ngbActiveModal.dismiss();
  }
  refreshTable() {
    this.apirestservice.PrimaNotaStockProdotti(this.Filtri).subscribe(data=>{
      this.List = data ?? [];
    });
  }
}
